export default {
  CREATE_ABOUTUS(state, payload) {},
  GET_ABOUTUS(state, payload) {
    state.aboutUs = payload;
  },
  EDIT_ABOUTUS(state, payload) {},
  DELETE_ABOUTUS(state, payload) {},
};
